import { useEffect, useRef } from "react";
import type { LogEntry } from "../hooks/useGameSession";

interface Props {
  entries: LogEntry[];
}

export function CaptainsLog({ entries }: Props) {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [entries]);

  return (
    <div className="captains-log" ref={scrollRef}>
      {entries.length === 0 && (
        <div className="log-empty">No entries yet.</div>
      )}
      {entries.map((e, i) => (
        <div key={i} className="log-entry">
          <span className="log-stardate">{e.stardate}</span>
          <span className="log-text">{e.text}</span>
        </div>
      ))}
    </div>
  );
}
